'use strict';
const angular = require('angular');

export class GaService {
  /*@ngInject*/
  constructor(private $http, private User, private Auth) {
  }
  event(fields){
    // window.ga('send', 'event', fields);
    window.gtag('event', fields.eventAction, {
      'event_category': fields.eventCategory,
      'event_label': fields.eventLabel,
      // 'value': <value>
    });

    window.dataLayer.push(Object.assign({}, fields, {event: 'myTrackEvent'}))

    let user = this.Auth.getCurrentUserSync();
    if(user){
      this.User.update({id: user._id}, {gaEvent: fields}).$promise
        .then((response) => {
          user.ga = fields;
          console.log('ga update done', response);
        });
    }
  }
}

export default angular.module('paizacloudApp.ga', [])
  .service('ga', GaService)
  .name;
